document.addEventListener("DOMContentLoaded", function () {
  //display the 3D configurator URL in cart more neatly
  if (document.body.classList.contains("template-cart")) {
    document.querySelectorAll(".line-item-property").forEach((el) => {
      if (el.textContent.includes("3D Customizer")) {
        // Find the URL in the element's text content
        const urlMatch = el.textContent.match(/https?:\/\/[^\s]+/);
        if (urlMatch) {
          const url = urlMatch[0];

          // Clear the element and insert the link
          el.innerHTML = `<a href="${url}#3dbuilder" target="_blank" style="text-decoration:underline" class="your-configurator-link">View Your Customised Product</a>`;
          el.classList.add("3d-customiser-url");
        }
      }
    });
  }

  // Function to execute when the #3dbuilder .pdf-export-icon element exists

  function onElementToMoveExists() {
    const builderElement = document.querySelector(
      ".tda-customizer-app-section-container"
    );

    if (window.innerWidth >= 1024) {
      const hostElement = document.querySelector(
        ".tda-app-section-model-viewer"
      );
      const shadowRoot = hostElement.shadowRoot;
      const elementToMove = shadowRoot.querySelector(".pdf-export-container");
      const destinationContainer = document.querySelector(
        ".tda-customizer-customization-options-container"
      );

      destinationContainer.appendChild(elementToMove);
      const textNode = document.createTextNode("Download your configuration");
      elementToMove.appendChild(textNode);
    }
  }

  // Initial check for the presence of the #3dbuilder element
  const builderElement = document.querySelector(
    ".tda-customizer-app-section-container"
  );
  if (builderElement) {
    // Check periodically for the existence of the #3dbuilder .pdf-export-icon element

    const intervalId = setInterval(function () {
      const hostElement = document.querySelector(
        ".tda-app-section-model-viewer"
      );
      const shadowRoot = hostElement.shadowRoot;
      const elementToMove = shadowRoot.querySelector(".pdf-export-container");
      if (elementToMove) {
        onElementToMoveExists();
        clearInterval(intervalId); // Stop checking once the element is found
      }
    }, 1000); // Check every 1s
  }
});
